const CMSUrl = '/cms';

export default CMSUrl;
